module.exports = __webpack_public_path__ + "static/media/channel=SMS.73e3ecb0.svg";